import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  orderDetail: null,
  loading: false,
  error: null,
};

// OrderDetail slice
const orderDetailSlice = createSlice({
  name: 'orderDetail',
  initialState,
  reducers: {
    setOrderDetail: (state, action) => {
      state.orderDetail = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    updateOrderStatus: (state, action) => {
      if (state.orderDetail) {
        state.orderDetail.orderStatus = action.payload;
      }
    },
  },
});

export const {
  setOrderDetail,
  setLoading,
  setError,
  updateOrderStatus,
} = orderDetailSlice.actions;

export default orderDetailSlice.reducer; 